/* eslint-disable require-jsdoc */
import { ThemeProvider } from "@material-ui/styles";
import { createBrowserHistory } from "history";
import { Chart } from "react-chartjs-2";
import { Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import validate from "validate.js";
import validators from "./common/validators";
import Routes from "./Routes";
import theme from "./theme";
import chartjs from "./helpers/chartjs";
//import { getToken } from './common/firebase';
import Analytics from "./components/analytics";

import "react-toastify/dist/ReactToastify.css";

import React, { useEffect } from "react";
import TagManager from "react-gtm-module";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./assets/scss/index.css";
import { ENVIRONMENT } from "./common/envConfig";
import { SwingLibraryProvider } from "./views/swing_library/store/swingLibraryStore";
import { NewtonProvider } from "./views/swing_library/components/Newton/store/NewtonContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const browserHistory = createBrowserHistory();

Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw,
});

validate.validators = {
  ...validate.validators,
  ...validators,
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 min
      cacheTime: 30 * 60 * 1000, // 30 min (v4 name; v5 calls this gcTime)
    },
  },
});
//getToken();

function App() {
  useEffect(() => {
    if (ENVIRONMENT === "production") {
      TagManager.initialize({
        gtmId: "GTM-MH5ZTMVN",
      });
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <SwingLibraryProvider>
          <Router history={browserHistory}>
            <NewtonProvider>
              <Analytics />
              <Routes />
            <ToastContainer
              autoClose={4000}
              draggableDirection="y"
              hideProgressBar={false}
              icon={false}
              newestOnTop={false}
              position="bottom-right"
              rtl={false}
            />
            </NewtonProvider>
          </Router>
        </SwingLibraryProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
